var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_7054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0028 22.1695C17.8728 22.1695 16.1328 20.4395 16.1328 18.2995C16.1328 16.1595 17.8728 14.4395 20.0028 14.4395C22.1328 14.4395 23.8728 16.1695 23.8728 18.3095C23.8728 20.4495 22.1328 22.1695 20.0028 22.1695ZM20.0028 15.9395C18.7028 15.9395 17.6328 16.9995 17.6328 18.3095C17.6328 19.6195 18.6928 20.6795 20.0028 20.6795C21.3128 20.6795 22.3728 19.6195 22.3728 18.3095C22.3728 16.9995 21.3028 15.9395 20.0028 15.9395Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0016 30.759C18.5216 30.759 17.0316 30.199 15.8716 29.089C12.9216 26.249 9.66164 21.719 10.8916 16.329C12.0016 11.439 16.2716 9.24902 20.0016 9.24902C20.0016 9.24902 20.0016 9.24902 20.0116 9.24902C23.7416 9.24902 28.0116 11.439 29.1216 16.339C30.3416 21.729 27.0816 26.249 24.1316 29.089C22.9716 30.199 21.4816 30.759 20.0016 30.759ZM20.0016 10.749C17.0916 10.749 13.3516 12.299 12.3616 16.659C11.2816 21.369 14.2416 25.429 16.9216 27.999C18.6516 29.669 21.3616 29.669 23.0916 27.999C25.7616 25.429 28.7216 21.369 27.6616 16.659C26.6616 12.299 22.9116 10.749 20.0016 10.749Z",
    fill: "#FFB600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.6bd224eb60066bf9891eab9359d87563.svg";
export { ForwardRef as ReactComponent };